import { render } from "./modal-view.vue?vue&type=template&id=698804f8&lang=html"
import script from "./modal-view.vue?vue&type=script&lang=js"
export * from "./modal-view.vue?vue&type=script&lang=js"

import "./modal-view.vue?vue&type=style&index=0&id=698804f8&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__